// extracted by mini-css-extract-plugin
export default {"wrapper":"EmptyLayout_wrapper__Ww72k","icon-home":"EmptyLayout_icon-home__kXvCC"};